import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllAtmModels } from "../api/getAllAtmModels";
import { useTranslation } from "react-i18next";

// All your logic is here
export const useAtmModelsDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetAtmModel []>([]);
  const getAllAtmModelsQuery = useGetAllAtmModels({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllAtmModelsQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllAtmModelsQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllAtmModelsQuery.data ? getAllAtmModelsQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Μοντέλο",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Μοντέλου");
        break;
      case "edit":
        title = t("Επεξεργασία Μοντέλου");
        break
        case "delete":
        title = t("Διαγραφή Μοντέλου");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getAllAtmModelsQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
